import { Component, computed, input, Signal } from '@angular/core';
import { ChipColor } from '../pan-chip/pan-chip.component';

export type TransactionType = 'Cancel' | 'Sold';

@Component({
  selector: 'app-pan-transaction-type',
  templateUrl: './pan-transaction-type.component.html',
  styleUrl: './pan-transaction-type.component.scss',
  standalone: false,
})
export class PanTransactionTypeComponent {
  public state = input.required<TransactionType>();

  public color: Signal<ChipColor> = computed(() => {
    switch (this.state()) {
      case 'Cancel':
        return 'warning';
      case 'Sold':
        return 'success';
      default:
        return 'info';
    }
  });
}
